import Vue from 'vue'
import Router from 'vue-router'

import EventBus, { State } from './library/EventBus.js'
import { scrollTop } from './library/Var.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'router-link-active active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return scrollTop()
    }
  },
  routes: [{
    path: '/',
    component: () => import('@/components/AppLayout'),
    children: [{
      path: '',
      name: 'home',
      component: () => import('@/components/Home'),
      meta: {
        title: '首頁'
      }
    }, {
      path: 'search',
      name: 'search',
      component: () => import('@/components/Search'),
      meta: {
        title: '搜尋'
      }
    }, {
      path: 'classify/:top/:sub?',
      name: 'classify',
      component: () => import('@/components/Classify'),
      meta: {
        title: '分類'
      }
    }, {
      path: 'prod/:id',
      name: 'production',
      component: () => import('@/components/Product'),
      meta: {
        title: '商品資訊'
      }
    }, {
      path: 'cart',
      name: 'cart',
      component: () => import('@/components/Cart'),
      meta: {
        title: '購物車'
      }
    }, {
      path: 'deliver',
      name: 'deliver',
      component: () => import('@/components/Deliver'),
      meta: {
        title: '交易紀錄'
      }
    }, {
      path: 'deliver/:id',
      name: 'deliver-info',
      component: () => import('@/components/DeliverInfo'),
      meta: {
        title: '交易資訊'
      }
    }, {
      path: 'checkout',
      name: 'checkout',
      component: () => import('@/components/Checkout'),
      meta: {
        authed: true,
        title: '結帳'
      }
    }, {
      path: 'login',
      name: 'login',
      component: () => import('@/components/Login'),
      meta: {
        title: '登入'
      }
    }, {
      path: 'personal',
      component: () => import('@/components/Personal'),
      name: 'personal-data',
      meta: {
        title: '個人資料'
      }
    }]
  }, {
    path: '/admin/login',
    component: () => import('@/components/admin/Login'),
    name: 'admin-login',
    meta: {
      title: '管理員登入'
    }
  }, {
    path: '/admin',
    component: () => import('@/components/admin/AdminLayout'),
    meta: {
      title: '商城管理',
      role: ['super', 'admin', 'editor'],
      goto: '/admin/login'
    },
    children: [{
      path: '',
      name: 'admin-overview',
      component: () => import('@/components/admin/Overview'),
      meta: {
        title: '概覽'
      }
    }, {
      path: 'panel',
      name: 'admin-panel',
      component: () => import('@/components/admin/AdminPanel'),
      meta: {
        title: '個人資料'
      }
    }, {
      path: 'classify',
      name: 'admin-classify',
      component: () => import('@/components/admin/Classify'),
      meta: {
        title: '分類管理'
      }
    }, {
      path: 'product',
      name: 'admin-production',
      component: () => import('@/components/admin/Product'),
      meta: {
        title: '商品管理'
      }
    }, {
      path: 'product/:id/edit',
      name: 'admin-production-edit',
      component: () => import('@/components/admin/ProductEdit'),
      meta: {
        title: '商品編輯'
      }
    }, {
      path: 'homeset/ads',
      name: 'admin-homeset-ads',
      component: () => import('@/components/admin/HomesetAds'),
      meta: {
        title: '輪播廣告'
      }
    }, {
      path: 'homeset/favors',
      name: 'admin-homeset-favors',
      component: () => import('@/components/admin/HomesetFavors'),
      meta: {
        title: '首頁推薦'
      }
    }, {
      path: 'users',
      name: 'admin-users-list',
      component: () => import('@/components/admin/Users'),
      meta: {
        title: '會員列表'
      }
    }, {
      path: 'users/:id/edit',
      name: 'admin-users-edit',
      component: () => import('@/components/admin/UsersEdit'),
      meta: {
        title: '會員編輯'
      }
    }, {
      path: 'users/:id/more',
      name: 'admin-users-more',
      component: () => import('@/components/admin/UsersMore'),
      meta: {
        title: '會員資訊'
      }
    }, {
      path: 'deliver',
      name: 'admin-deliver',
      component: () => import('@/components/admin/Deliver'),
      meta: {
        title: '訂單查詢'
      }
    }, {
      path: 'deliver/ctrl',
      name: 'admin-deliver-ctrl',
      component: () => import('@/components/admin/DeliverCtrl'),
      meta: {
        title: '取貨管理'
      }
    }, {
      path: 'deliver/:id/view',
      name: 'admin-deliver-view',
      component: () => import('@/components/admin/DeliverView'),
      meta: {
        title: '訂單明細'
      }
    }, {
      path: 'statistics/production',
      name: 'admin-statistics-production',
      component: () => import('@/components/admin/StatisticsProduction'),
      meta: {
        title: '商品統計'
      }
    }, {
      path: 'statistics/deliver',
      name: 'admin-statistics-deliver',
      component: () => import('@/components/admin/StatisticsDeliver'),
      meta: {
        title: '訂單統計'
      }
    }, {
      path: 'control/glob',
      name: 'admin-control-glob',
      component: () => import('@/components/admin/ControlGlob'),
      meta: {
        title: '商城設定'
      }
    }, {
      path: 'control/payment',
      name: 'admin-control-payment',
      component: () => import('@/components/admin/ControlPayment'),
      meta: {
        title: '金流設定'
      }
    }, {
      path: 'control/sub-admin',
      name: 'admin-control-sub-admin',
      component: () => import('@/components/admin/ControlSubAdmin'),
      meta: {
        title: '管理權限'
      }
    }, {
      path: 'control/records',
      name: 'admin-control-records',
      component: () => import('@/components/admin/ControlRecords'),
      meta: {
        title: '操作歷程'
      }
    }, {
      path: '*',
      redirect: '/admin'
    }]
  }]
})

router.beforeEach(async (to, from, next) => {
  // check login or not
  const r = to.matched.find(r => r.meta.role)
  const authed = to.matched.find(r => r.meta.authed)
  const titleAry = to.matched.map(r => r.meta.title).filter(r => !!r)
  State.currPageName = titleAry.join('-')
  EventBus.$emit('update:user', user => {
    if (r) {
      const { goto, role } = r.meta
      console.log('check user is match role %O', role)
      if (role.indexOf(user.role) === -1) {
        console.log('user is been denied, redirect to %s', goto)
        next(goto || '/')
      } else {
        next()
      }
    } else if (authed) {
      if (user.id) {
        next()
      } else {
        next({path: '/login', query: { nextUrl: to.fullPath }})
      }
    } else {
      next()
    }
  })
})

router.afterEach()

export default router
